import React from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import FormContainer from '../../../FormContainer';

import VendorContactService from '../../../../../services/VendorContactService';
import useContactForm from '../../../../../forms/vendor/contact';
import { useUiContext } from '../../../../../context/UiContext';

export default function Contact() {
  const { showToast } = useUiContext();

  const { contactId } = useParams();

  const { data: contact, refetch } = useQuery({
    queryKey: ['contact', contactId],
    queryFn: () => VendorContactService.getVendorContact(contactId),
    enabled: !!contactId,
  });

  const { mutate: updateContact } = useMutation({
    mutationFn: (formValues) =>
      VendorContactService.updateVendorContact({ formValues, contactId }),
    onSuccess: () => {
      refetch();
      showToast({ type: 'success', text: 'Contact updated successfully' });
    },
    onError: (error) => {
      showToast({
        type: 'error',
        text: error?.response?.data?.message || 'Something went wrong',
      });
    },
  });

  const form = useContactForm(updateContact, contact, true);

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer form={form} data={contact} noBillComId />
    </div>
  );
}
